



































































































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import IconConstants from '@/lib/IconConstants';
import ProductType from "@/models/Products/ProductType";
import Payee from '@/models/Accounts/Shared/Payees/Payee';
import PayeeState from '@/components/Accounts/Shared/Payees/PayeeState.vue';
import PayeeCreate from '@/components/Accounts/Shared/Payees/PayeeCreate.vue';
import PermissionUtils from '@/lib/permissionUtils';
import PermissionType from '@/models/Settings/Roles/PermissionType';

@Component({ name: 'Payees', components: { PayeeState, PayeeCreate } })
export default class extends SaascadaVue {

    @Prop({required: true})
    accountId: string;

    @Prop({required: true})
    isCustomerAccount: boolean;

    @Prop({required: true})
    productType: ProductType;

    PermissionUtils = PermissionUtils;
    payeesPage = 1;
    headers = [
        { text: this.$t('pageText.depositAccounts.fields.name'), width: "40%", sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.reference'), width: "40%", sortable: false },
        { text: this.$t('pageText.depositAccounts.fields.state'), width: "20%", sortable: false }
    ];

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.payeesPage = +page;
        }
    }

    async beforeMount() {
        if (this.isCustomerAccount) {
            if (this.productType === ProductType.Deposit) {
                await DepositAccountModule.getPayees(this.payeesPage);
            }
        }
        else {
            await InstitutionAccountModule.getPayees({ id: this.accountId, pageNumber: this.payeesPage });
        }
    }

    async getPayees() {
        if (this.isCustomerAccount) {
            if (this.productType === ProductType.Deposit) {
                await DepositAccountModule.getPayees(this.payeesPage);
            }
        }
        else {
            await InstitutionAccountModule.getPayees({ id: this.accountId, pageNumber: this.payeesPage });
        }
    }

    @Watch('payeesPage')
    async onPayeesPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.payeesPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.payeesPage}` } });
        }
        // Get new payees
        if (this.isCustomerAccount) {
            if (this.productType === ProductType.Deposit) {
                await DepositAccountModule.getPayees(this.payeesPage);
            }
        }
        else {
            await InstitutionAccountModule.getPayees({ id: this.accountId, pageNumber: this.payeesPage });
        }
    }

    async updateCurrentPayee(payee: Payee) {
        if (this.isCustomerAccount) {
            if (this.productType === ProductType.Deposit) {
                await DepositAccountModule.updateCurrentPayee(payee);
            }
        }
        else {
            await InstitutionAccountModule.updateCurrentPayee(payee);
        }
    }

    get checkPermissions() {
        if (this.isCustomerAccount) {
            if (this.productType === ProductType.Deposit) {
                return PermissionUtils.hasPermission(PermissionType.DepositAccountsManage);
            }
            else {
                return false;
            }
        }
        else {
            return PermissionUtils.hasPermission(PermissionType.InstitutionalAccountsManage);
        }
    }

    get currentPayee() {
        if (this.isCustomerAccount) {
            if (this.productType === ProductType.Deposit) {
                return DepositAccountModule.currentPayee;
            }
            else {
                return new Payee();
            }
        }
        else {
            return InstitutionAccountModule.currentPayee;
        }
    }

    get loading() {
        if (this.isCustomerAccount) {
            if (this.productType === ProductType.Deposit) {
                return DepositAccountModule.loadingPayees;
            }
            else {
                return false;
            }
        }
        else {
            return InstitutionAccountModule.loadingPayees;
        }
    }

    get totalPayeesPages() {
        if (this.isCustomerAccount) {
            if (this.productType === ProductType.Deposit) {
                return DepositAccountModule.totalPayeesPages;
            }
            else {
                return 1;
            }
        }
        else {
            return InstitutionAccountModule.totalPayeesPages;
        }
    }

    get pageSize() {
        if (this.isCustomerAccount) {
            if (this.productType === ProductType.Deposit) {
                return DepositAccountModule.pageSize;
            }
            else {
                return LendingAccountModule.pageSize;
            }
        }
        else {
            return InstitutionAccountModule.pageSize;
        }
    }

    get payees() {
        if (this.isCustomerAccount) {
            if (this.productType === ProductType.Deposit) {
                return DepositAccountModule.payees;
            }
            else {
                return [];
            }
        }
        else {
            return InstitutionAccountModule.payees;
        }
    }

    async deletePayee() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this payee?', options);
        if (result) {
            if (this.isCustomerAccount) {
                if (this.productType === ProductType.Deposit) {
                    await DepositAccountModule.deletePayee();
                    await DepositAccountModule.getPayees(1);
                }
            }
            else {
                await InstitutionAccountModule.deletePayee();
                await InstitutionAccountModule.getPayees({ id: this.accountId, pageNumber: 1 });
            }
        }
    }

}
